import Request from './request'

const Status = {
  getMonitoringStatus(callback) {
    Request.post('monitoring-status/index').then(callback).catch(this.bad_answer)
  },
  //TODO move to new file
  getProxyServers(callback) {
    Request.post('proxy-servers/index').then(callback).catch(this.bad_answer)
  },
  getToken (params, callback) {
    Request.post('proxy-servers/get-token', JSON.stringify(params)).then(callback).catch(this.bad_answer)
 },
}

export default Status
